var _rect, _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAddCustomerIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    rx: 5.16129,
    fill: "#7EC242"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20.6484 11.6129V27.0968",
    stroke: "white",
    strokeWidth: 2.58065
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.9062 19.3549H28.3901",
    stroke: "white",
    strokeWidth: 2.58065
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddCustomerIcon);
export default __webpack_public_path__ + "static/media/add_customer_icon.da4801ef05d2e111c6913030d51835cc.svg";
export { ForwardRef as ReactComponent };